var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"raison-btn rai-btn ma-2 pa-4 darken-3",attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._v(" "+_vm._s(_vm.$t(_vm.shortLabelCode))+" ")]),_vm._v(" "+_vm._s(_vm.$t(_vm.answerLabelCode))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }